import React from 'react'
import { Button, Modal } from 'react-bootstrap'
import { useSearchParams } from 'react-router'

import { SEARCH_PARAMS } from '../../pages/emailAndCalendarIntegration/constants'
import OpenChatButton from '../misc/OpenChatButton'

const NylasCalendarConnectionFailedModal: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams()

  const shouldShow =
    searchParams.get(SEARCH_PARAMS.calendarConnectionFailed) === 'true'

  if (!shouldShow) {
    return null
  }

  function onHide() {
    searchParams.delete(SEARCH_PARAMS.calendarConnectionFailed)
    setSearchParams(searchParams)
  }

  return (
    <Modal show onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Please try connecting again</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p>
          Sorry but we were unable to connect to your calendar. This can
          sometimes happen because of temporary issues with the calendar
          provider (e.g., Outlook, Google, etc.) and can usually be resolved by
          trying again. Please try reconnecting your calendar now.
        </p>

        <p>
          If the issue persists, please{' '}
          <OpenChatButton>get in touch</OpenChatButton> and we can help.
        </p>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="outline-secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default NylasCalendarConnectionFailedModal
